<app-spinner></app-spinner>
<div class="container-fluid" style="overflow-x: auto;">
    <div class="row px-4" class="shadow-wrapper my-3">
        <div class="row py-1">
            <div class="col-12">
                <h3 class="dashboard">Ticket Id : {{prevViewFileObj['ticket_id']}}</h3>
            </div>
        </div>
        <div class="row py-1 mb-3">
            <div class="col-12 d-flex justify-content-end">
                <h4 class="dashboard cursor-pointer hover-blue" style="color: rgb(24, 107, 202);" (click)="back()"
                    role="button">
                    < Back </h4>
            </div>
        </div>

        <div class="row py-1 mb-3">
            <div class="col-12 d-flex justify-content-end align-items-center">
                <h6> Status : {{prevViewFileObj['status']}}</h6>
            </div>
        </div>
        <div class="row py-1 mb-3 responsive-row">
            <div class="col-2 responsive-label">
                <h6> Full Name</h6>
            </div>
            <div class="col-1 responsive-separator">
                <h6>:</h6>
            </div>
            <div class="col-3 responsive-value">
                {{prevViewFileObj['full_name']}}
            </div>
            <div class="col-2 responsive-label">
                <h6> Mobile No.</h6>
            </div>
            <div class="col-1 responsive-separator">
                <h6>:</h6>
            </div>
            <div class="col-3 responsive-value">
                {{prevViewFileObj['mobile_no']}}
            </div>
        </div>
        <div class="row py-1 mb-3">
            <div class="col-2">
                <h6>Complaint Department</h6>
            </div>
            <div class="col-1">
                <h6>:</h6>
            </div>
            <div class="col-9">
                {{prevViewFileObj['departments']}}
            </div>
        </div>
        <div class="row py-1 mb-3">
            <div class="col-2">
                <h6>Complaint Description</h6>
            </div>
            <div class="col-1">
                <h6>:</h6>
            </div>
            <div class="col-9">
                {{prevViewFileObj['complaint_desc']}}
            </div>
        </div>


        <div class="row py-1 mb-3">
            <div class="col-2 responsive-label">
                <h6>Zone</h6>
            </div>
            <div class="col-1 responsive-separator">
                <h6>:</h6>
            </div>
            <div class="col-3 responsive-value">
                {{prevViewFileObj['zone']}}
            </div>
            <div class="col-2 responsive-label">
                <h6> Ward</h6>
            </div>
            <div class="col-1 responsive-separator">
                <h6>:</h6>
            </div>
            <div class="col-3 responsive-value">
                {{prevViewFileObj['ward']}}
            </div>
        </div>
        <div class="row py-1 mb-3">
            <div class="col-2">
                <h6>mohalla</h6>
            </div>
            <div class="col-1">
                <h6>:</h6>
            </div>
            <div class="col-3">
                {{prevViewFileObj['mohalla']}}
            </div>
        </div>
        <div class="row py-1 mb-3">
            <div class="col-2">
                <h6> Uploaded Document</h6>
            </div>
            <div class="col-1">
                <h6>:</h6>
            </div>
            <div class="col-9">
                <div *ngIf="prevViewFileObj['com_doc'] !== 'N/A' || (prevViewFileObj['others_doc'] == 'N/A' &&  ['CLOSED','RESOLVED'].includes(prevViewFileObj['status'])); else com_doc"
                    [ngClass]="prevViewFileObj['com_doc'] === 'N/A' ? 'black-underline' : 'green-underline'"
                    class="cursor-pointer" role="button" (click)="viewDoc(prevViewFileObj, 'com_doc', 'com')">
                    {{ prevViewFileObj['com_doc'] }}
                </div>

                <!-- <div *ngIf="prevViewFileObj['com_doc'] === 'N/A' && editMode !== true">
                    <button class="btn btn-sm btn-warning" (click)="onEditClick('com_doc')">Edit</button>
                </div>  -->

                <ng-template #com_doc>
                    <input type="file" (change)="checkFile($event, 'com')" class="upload" />
                    <button class="btn btn-sm btn-primary upload" [disabled]="!selectedFileUrlObj?.com?.file_name"
                        (click)="upload('com')">Upload</button>
                </ng-template>
            </div>
        </div>
        <div class="row py-1 mb-3">
            <div class="col-2">
                <h6>Other Document</h6>
            </div>
            <div class="col-1">
                <h6>:</h6>
            </div>
            <div class="col-9">
                <div *ngIf="prevViewFileObj['others_doc'] !== 'N/A' || (prevViewFileObj['others_doc'] == 'N/A' &&  ['CLOSED','RESOLVED'].includes(prevViewFileObj['status'])) ;else others_doc"
                    [ngClass]="prevViewFileObj['others_doc'] === 'N/A' ? 'black-underline' : 'green-underline'"
                    class="cursor-pointer" role="button" (click)="viewDoc(prevViewFileObj, 'others_doc', 'others')">
                    {{ prevViewFileObj['others_doc'] }}
                </div>


                <!-- <div *ngIf="prevViewFileObj['others_doc'] === 'N/A' && !editMode">
                        <button class="btn btn-sm btn-warning" (click)="onEditClick('others_doc')">Edit</button>
                    </div> -->

                <ng-template #others_doc>
                    <div style="margin-left: 4px;">
                        <input type="file" (change)="checkFile($event, 'others')" class="upload" />
                        <button class="btn btn-sm btn-primary" [disabled]="!selectedFileUrlObj?.others?.file_name"
                            (click)="upload('others')">Upload</button>
                    </div>
                </ng-template>
            </div>

        </div>

        <div class="my-3 ">
            <h5 class="font-bold fs-5">Instant Resolution Details</h5>
        </div>

        <div class="row py-1 mb-3" *ngIf="prevViewFileObj['is_instant_resolved'] ; else IsInstant">

            <div class="row">
                <div class="col-2 mb-3">
                    <h6>Is Instant Resolved </h6>
                </div>
                <div class="col-1 mb-3">
                    <h6>:</h6>
                </div>
                <div class="col-9 mb-3">
                    Yes
                </div>
            </div>
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-2">
                    <h6>Remark</h6>
                </div>
                <div class="col-1">
                    <h6>:</h6>
                </div>
                <div class="col-9 mb-3 ">
                    <div>{{prevViewFileObj['resolved_remark']}}</div>
                </div>
            </div>
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-2">
                    <h6>Approval Description</h6>
                </div>
                <div class="col-1">
                    <h6>:</h6>
                </div>
                <div class="col-9 mb-3 ">
                    <div>{{prevViewFileObj['approval_desc']}}</div>
                </div>
            </div>
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-2 mb-3">
                    <h6>Uploaded Document</h6>
                </div>
                <div class="col-1 mb-3">
                    <h6>:</h6>
                </div>
                <div class="col-9 mb-3 d-flex">
                    <div *ngIf="prevViewFileObj['resolved_doc'] !== 'N/A' || (prevViewFileObj['others_doc'] == 'N/A' &&  ['CLOSED','RESOLVED'].includes(prevViewFileObj['status'])); else resolved_doc"
                        [ngClass]="prevViewFileObj['resolved_doc'] === 'N/A' ? 'black-underline' : 'green-underline'"
                        class="cursor-pointer" role="button"
                        (click)="viewDoc(prevViewFileObj, 'resolved_doc', 'resolved')">
                        {{ prevViewFileObj['resolved_doc'] }}
                    </div>
                    <!-- <div *ngIf="prevViewFileObj['resolved_doc'] === 'N/A' && !editMode">
                        <button class="btn btn-sm btn-warning" (click)="onEditClick('resolved_doc')">Edit</button>
                    </div> -->
                    <ng-template #resolved_doc>
                        <input type="file" (change)="checkFile($event, 'resolved')" />
                        <button class="btn btn-sm btn-primary" [disabled]="!selectedFileUrlObj?.resolved?.file_name"
                            (click)="upload('resolved')">Upload</button>
                    </ng-template>
                </div>
            </div>
        </div>
        <ng-template #IsInstant>
            <div class="row py-1 mb-3">
                <div class="col-2 mb-3">
                    <h6>Is Instant Resolved </h6>
                </div>
                <div class="col-1 mb-3">
                    <h6>:</h6>
                </div>
                <div class="col-9 mb-3">
                    No
                </div>
            </div>
        </ng-template>

        <div class="row py-1 mb-3">
            <div class="col-12 mb-2">
                <h5 class="font-bold fs-5">Others Details</h5>
            </div>
            <div class="row my-3">
                <div class="col-3">
                    <h6> Status</h6>
                </div>

                <div class="col-3 ">
                    <h6>Name</h6>
                </div>
                <div class="col-3">
                    <h6>Date</h6>
                </div>
                <div class="col-3">
                    <h6>Document</h6>
                </div>
            </div>
            <div class="table-responsive-sm">
                <div *ngFor="let obj of logs" class="row my-3">
                    <div class="col-3">
                        {{ obj['status'] === 'REGISTERED' ? 'Registered by' : obj['status'] === 'PENDING' ? 'Pending at'
                        :
                        obj['status'] === 'CLOSED' ? 'Closed by' : obj['status'] === 'RESOLVED' ? 'Resolved by' :'N/A'
                        }}
                    </div>

                    <div class="col-3">
                        {{obj['user_name']}}
                    </div>
                    <div class="col-3">
                        {{ obj['status'] === 'CLOSED' ? obj['created_date'] : obj['status'] === 'RESOLVED' ?
                        obj['updated_date'] : obj['created_date'] ? obj['created_date'] : 'N/A' }}
                    </div>
                    <div class="col-3">
                        <div *ngIf="obj['upload_doc']=='N/A' ;else upload_doc">
                            {{obj['upload_doc']}}
                        </div>
                        <ng-template #upload_doc class="cursor-pointer">
                            <div [ngClass]="obj['upload_doc'] === 'N/A' ? 'black-underline' : 'green-underline'"
                                class="cursor-pointer" role="button"
                                (click)="viewDoc(obj, 'upload_doc', obj['status'] === 'RESOLVED'?'resolved':'closed')">
                                {{ obj['upload_doc'] }}
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>


        <div class="row d-flex update-print">
            <div class="col-2  d-none d-sm-block"></div>
            <div class="col-2  d-none d-sm-block"></div>
            <div class="col-2  d-none d-sm-block"></div>
            <div class="col-2  d-none d-sm-block"></div>
            <div class="col-12 col-sm-2 button-container position-relative">
                <h6 class="update-btn w-75 text-center"
                    *ngIf="erpUser.role_cd.includes('Officer')  && appr_flag"
                    (click)="route(prevViewFileObj)"
                    style="position: absolute;bottom: 2px;right: 1px; background: whitesmoke; color: rgb(134, 134, 135); text-decoration: underline;font-size: 14px; padding: 10px; cursor: pointer;  box-shadow: -1px 1px 4px 0px rgba(136, 132, 161, 0.25), 1px -1px 4px 0px rgba(136, 132, 161, 0.25), -1px -1px 4px 0px rgba(136, 132, 161, 0.25), 1px 1px 4px 0px rgba(136, 132, 161, 0.25); z-index: 1;">
                    Update
                </h6>
            </div>
            <div class="col-12 col-sm-2 button-container position-relative mb-2 mb-sm-0">
                <h6 class="print-btn w-75 text-center"
                    style="position: absolute;bottom: 2px; right: 6px;  background: whitesmoke; color: rgb(1, 159, 244); text-decoration: underline;font-size: 14px; padding: 10px; cursor: pointer;  box-shadow: -1px 1px 4px 0px rgba(136, 132, 161, 0.25), 1px -1px 4px 0px rgba(136, 132, 161, 0.25), -1px -1px 4px 0px rgba(136, 132, 161, 0.25), 1px 1px 4px 0px rgba(136, 132, 161, 0.25); z-index: 1;"
                    (click)="onDownloadPDF(prevViewFileObj);" title="Print form as PDF">
                    Print Form
                </h6>
            </div>
            
        </div>
    </div>




</div>